import React from "react";
import { HowToText } from "./HowToText";
export const HowTo = () => {
    return (React.createElement("div", { className: "container cms-article" },
        React.createElement("div", { className: "cms-numbers-hd" },
            React.createElement("h1", null, "Podm\u00EDnky \u00FA\u010Dasti v elektronick\u00E9 aukci")),
        React.createElement(HowToText, null)));
};
